import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class TelecallerTempAssignService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    private baseUrl = 'api/telecallerTempAssign';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    getList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    getTelecallerList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getTelecallerList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    getAllFollowupUserList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getAllFollowupUserList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    getPreviewCount(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getPreviewCount`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    create(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/create`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }

    revoke(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/revoke`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }

    getActiveTempAssign(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getActiveTempAssign`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/telecallerTempAssign.service.ts